export const dateFormat = 'YYYY年M月D日';

export const monthFormat = 'YYYY年M月';

export const fullDateFormat = 'YYYY年M月D日 H:mm:ss'

export const formatNumber = num => {
  return new Intl.NumberFormat().format(num);
};
